import type { LandingDict } from './en';

const ko: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "앱 만들기", org: "My Org", pricing: '가격', privacy: "개인정보 보호", contact: "문의하기", language: '언어' },
  hero: {
    titlePre: '나만의 ',
    titleMark: '로컬 AI',
    titlePost: '\n파워하우스.',
    sub: "전문 지식, 스프레드시트, 회의를 답변, 차트, 슬라이드로. 어떤 데이터도 Mac 밖으로 나가지 않습니다.",
    watch: "2분 영상 보기",
    pill: "최신 버전",
    chip: "Wi‑Fi 꺼짐 · 전송 0바이트",
    badges: { offline: "오프라인 작동", server: "우리 서버가 아닌 당신의 서버", free: "무료로 시작" },
    reqs: 'Apple Silicon 탑재 Mac 필요 · 최소 16GB 메모리 · 32GB 이상이면 더 큰 추천 모델 사용 가능',
  },
  stats: {
    free: '무료',
    freeSub: '모든 Chat Apps, 모델 다운로드와 업데이트 — 언제나 무료',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: '이 Mac에서 AI를 실행할 때 클라우드로 전송되는 바이트',
    langsSub: '인터페이스 언어 지원, 한국어부터 日本語까지',
  },
  film: { kicker: '필름', title: 'Estha, 직접 확인해 보세요.', watchOnYouTube: 'YouTube에서 보기', trouble: '재생이 안 되나요? YouTube에서 보기 ↗' },
  overview: {
    kicker: '하나의 앱, 네 가지 방식',
    title: '대화에서 에이전트로,\n팀 전체가 쓰는 앱까지.',
    explore: '살펴보기',
    chat: { title: 'Chat Apps', desc: '교과서, 플레이북, 전문 지식 등 엄선된 지식 베이스에 기반한 AI 전문가.', tag: '언제나 무료' },
    agentic: { title: 'Agentic Apps', desc: '복잡한 작업을 처음부터 끝까지 처리하는 작업 중심의 AI 에이전트.', tag: '{n}개, 계속 늘어나는 중' },
    build: { title: "앱 만들기", desc: 'Quick Bot으로 내 자료를 Chat App으로 만들거나, Playground 캔버스에서 흐름을 자유롭게 구성하세요.', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: '검토를 거친 앱과 세밀한 접근 권한을 갖춘, 조직 브랜드의 전용 앱 공간.', tag: '엔터프라이즈' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: '진짜 지식에 기반한\nAI 전문가.',
    freePill: '언제나 무료',
    lede: '모든 Chat App에는 고유한 지식 베이스가 들어 있으며, Mac에서 바로 인덱싱됩니다.',
    feats: {
      kb: { title: '로컬 지식 베이스', desc: '앱을 설치하면 지식 베이스가 로컬에 생성됩니다. 답변은 엄선된 자료에서 나옵니다.' },
      files: { title: '내 파일 첨부', desc: '이미지, PDF, DOCX, TXT, MD를 첨부할 수 있습니다. 긴 문서는 스마트 검색을 사용합니다.' },
      browse: { title: '탐색, 고정, 즐겨찾기', desc: '평가부터 커리어까지 다양한 카테고리, 새 앱에는 NEW 태그, ⌘K로 모든 것을 검색.' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n}개의 Agentic Apps.\n그리고 계속 늘어납니다.',
    lede: '스프레드시트, PDF, 녹음 파일, 혹은 아이디어 하나에서 완성된 차트, 프레젠테이션, 문서, 프로토타입까지. 모두 Mac에서 비공개로.',
    seeThem: '실제 작동 모습 보기',
  },
  build: {
    kicker: '앱 만들기',
    title: '나만의 Chat App을 만드세요.\n바로 내 Mac에서.',
    lede: '내 파일을 Chat App으로. 로컬에서 인덱싱하고, 준비되면 게시하세요.',
    quick: {
      badge: '추천',
      desc: '지식 베이스를 업로드하고 시스템 프롬프트를 작성한 후 게시하세요. 자료를 빠르게 Q&A 봇으로 만드는 데 적합합니다.',
      items: ['한 페이지 양식, 몇 단계로 완료', '바로 사용할 수 있는 지식 베이스 Q&A', '영감을 주는 내장 프롬프트 템플릿'],
    },
    advanced: {
      title: '고급 · Playground',
      desc: '시각적 노드 편집기로 여러 노드, 분기, AB test, 키워드 라우팅을 자유롭게 구성할 수 있습니다.',
      items: ['노드 캔버스', '다중 노드 / 분기 / AB test', '세밀한 필드 및 디버깅'],
    },
    guideTitle: '로컬 AI 빌드 가이드가 곁에서 돕습니다.',
    guideText: '앱이 무엇을 하길 원하는지 말하면, 어떤 노드를 끌어와 어떻게 연결할지 차근차근 안내합니다. 앱 만들기는 프리미엄에 포함됩니다.',
  },
  private: {
    kicker: '설계 단계부터 프라이빗',
    title: "데이터는 클라우드로 보내지 않습니다.\n작업은 추적하지 않습니다.",
    lede: "AI가 실행될 위치는 직접 정합니다. Estha가 기능마다 알맞은 모델을 기본으로 고르고, 앱에서 언제든 모델을 바꿀 수 있습니다.",
    boundary: "데이터 경계 = 내 네트워크",
    local: { title: '이 Mac에서', desc: '완전히 오프라인이며 데이터가 이 기기를 벗어나지 않습니다. 이 컴퓨터의 메모리로 모델을 실행합니다.', best: '메모리가 넉넉한 Mac에 적합' },
    server: { title: '내 Estha Server에서', desc: '무거운 작업을 네트워크의 더 강력한 Mac에 넘기고 이 Mac은 가볍게 유지합니다.', best: '노트북이나 메모리가 적은 Mac에 적합' },
    cluster: { desc: 'Mac Studio Cluster에 연결하여 데이터를 온프레미스에 유지하면서 무거운 추론을 오프로드하세요.', best: '네트워크에서 Estha Studio Master 노드를 자동으로 찾습니다' },
    models: {
      every: '지원되는 모든 Mac에서 실행',
      whisper: "음성 전사용 Whisper",
      recommended: '추천 모델',
      larger: "더 큰 Qwen·Gemma 모델",
      vision: "이미지를 이해하는 비전 모델",
      open: 'Apple Silicon에 최적화된 오픈 모델',
      openItems: ['앱 안에서 모델 다운로드 및 전환', '코딩 및 임베딩 전용 모델', '모델 다운로드는 언제나 무료'],
    },
  },
  org: {
    kicker: 'My Org',
    title: '우리 조직만의\nAI 앱 공간.',
    lede: 'Estha 안에 조직의 브랜드로 꾸민 공간. 구성원을 위해 조직이 검토한 앱이 모여 있습니다.',
    signIn: 'My Org Admin에 로그인',
    talk: 'Estha 팀에 문의하기',
    feats: {
      review: { title: '게시 전 검토', desc: '새 앱, 업데이트, 삭제는 모두 관리자 검토를 거칩니다. 반려 시에는 항상 서면 피드백이 함께 제공됩니다.' },
      access: { title: '그룹 또는 개인별 접근 권한', desc: '부서, 팀, 개인 단위로 각 앱을 볼 수 있는 사람을 정확히 지정하세요.' },
      brand: { title: '앱 속에 담긴 우리 브랜드', desc: '조직 이름, 환영 메시지, 로고, 배너, 테마 색상까지. 적용 전에 미리 확인할 수 있습니다.' },
    },
  },
  pricing: {
    kicker: '멤버십',
    title: '무료로 시작하고,\n필요할 때 모든 기능을.',
    free: { name: '무료', sub: '언제나 무료.', items: ["모든 Chat Apps", 'Document Processing, 평생 무료', '모델 다운로드, 소프트웨어 및 업데이트 — 항상 무료'] },
    premium: {
      name: '프리미엄', flag: '14일 무료 체험', firstYear: '첫해',
      sub: '이후 연 $30. 이메일 인증 후 14일 무료 체험으로 시작하세요.',
      items: ['무료 등급의 모든 권한 포함', '현재 및 향후 모든 Agentic Apps', 'Chat App 빌더 — 로컬 챗봇 생성, 편집, 미리보기, 저장 및 게시'],
      cta: '앱에서 체험 시작하기',
    },
    enterprise: {
      name: '엔터프라이즈', price: '문의하기', sub: '팀 단위로 Estha를 도입하는 조직을 위한 플랜.',
      items: ['프리미엄 등급의 모든 권한 포함', '팀을 위한 맞춤형 Chat Apps 및 Agentic Apps', 'Estha Server 앱 기능', 'My Org 앱 공간 및 My Org Admin'],
    },
  },
  faq: {
    title: '다운로드 전에\n알아 두면 좋은 것들.',
    spec: { chip: '칩', memory: '메모리', memMin: '최소 16GB', memRec: '추천 모델은 32GB 이상', languages: '언어', langsVal: '13개 인터페이스 언어', version: '최신 버전' },
    qa: [
      { q: '데이터가 Mac 밖으로 나가나요?', a: '이 Mac에서 AI를 실행하면 완전히 오프라인으로 작동하며, 어떤 데이터도 기기를 벗어나지 않습니다. Estha Server나 Mac Studio Cluster를 선택하면, 작업은 사용자의 네트워크 안에 있는 해당 기기로만 전송됩니다.' },
      { q: "인터넷 연결이 필요한 작업은?", a: "몇 가지뿐입니다. 로그인, Premium 체험을 위한 이메일 인증, 모델 다운로드, 업데이트 확인, 그리고 가끔 이루어지는 멤버십 확인. 프롬프트, 파일, 결과는 절대 업로드되지 않으며, 모델을 받은 뒤에는 AI가 완전히 오프라인으로 작동합니다." },
      { q: "Estha의 서버는 무엇을 볼 수 있나요?", a: "계정 운영에 필요한 정보뿐입니다. 로그인 정보, 멤버십 상태, 업데이트 확인용 앱 버전, 그리고 스토어에서 둘러본 앱입니다. 채팅, 파일, 회의, 그리고 Estha for Mac에서 만든 앱은 모두 Mac에 남으며, 저희는 이를 받지 않습니다. 조직이 My Org를 통해 게시한 앱은 구성원의 Mac에 배포할 수 있도록 저희 서버에 저장됩니다." },
      { q: "Estha가 제 데이터를 보관하거나 AI 학습에 사용하나요?", a: "아니요. 프롬프트와 파일은 Mac에서 처리되고 저희에게 전달되지 않으므로, 저희가 보관하거나 학습에 쓸 데이터 자체가 없습니다. 다운로드한 오픈소스 모델도 사용자의 데이터로 학습되지 않습니다. 채팅 기록은 Mac에만 저장되며 언제든지 삭제할 수 있습니다." },
      { q: "데이터는 어디에 저장되나요?", a: "사용자 본인의 macOS 계정 안, ~/Library/Application Support/Estha에 저장됩니다. 같은 Mac의 다른 사용자는 열 수 없습니다. Mac을 분실하더라도 데이터가 암호화되어 있도록 FileVault를 켜 두는 것을 권장합니다. 비밀번호는 Mac에 저장되지 않습니다." },
      { q: '무료와 프리미엄은 어떻게 다른가요?', a: '모든 Chat Apps, Document Processing, 모델 다운로드와 업데이트는 무료입니다. 프리미엄은 현재 및 향후 모든 Agentic Apps와 Chat App 빌더를 제공하며, 14일 무료 체험이 가능합니다.' },
      { q: "사용량 제한이나 크레딧이 있나요?", a: "없습니다. 크레딧도, 구매해야 할 토큰도, 일일 한도도 없습니다. AI가 사용자의 Mac에서 실행되므로, 얼마나 쓸 수 있는지는 오직 Mac의 메모리와 칩에 달려 있습니다." },
      { q: '어떤 AI 모델을 사용하나요?', a: 'Qwen, Gemma 같은 선도적인 오픈소스 모델과 음성 전사용 Whisper를 Apple의 MLX 엔진으로 실행합니다. 모델은 앱 안에서 다운로드하고 전환할 수 있습니다.' },
      { q: "어떤 안전장치가 있나요?", a: "업로드한 문서는 정보로만 취급되며, AI에 대한 지시로 처리되지 않습니다. PDF 리더는 각 답변의 근거가 된 구절을 정확히 인용하고, 문서에 답이 없으면 그렇다고 알려 줍니다. Data Analyst가 작성한 코드는 제한된 샌드박스에서 실행되며, Vibe Coding 미리보기는 인터넷에 접속할 수 없습니다. Estha는 Apple의 서명 및 공증을 받았습니다." },
      { q: '앱을 직접 만들 수 있나요?', a: '네. Quick Bot을 사용하면 파일을 최대 3개까지 올려 몇 단계 만에 지식 베이스 기반 Chat App을 만들 수 있습니다. 분기, AB test, 퀴즈가 필요하다면 Playground의 노드 캔버스를 사용하세요. 로컬 빌드 가이드가 과정 내내 도와줍니다.' },
      { q: '조직에는 어떻게 도입하나요?', a: '엔터프라이즈 플랜에서는 관리자가 My Org Admin에서 사용자와 그룹을 관리하고, 모든 앱을 게시 전에 검토합니다. 구성원은 Estha 안에서 조직 브랜드의 My Org 공간을 사용하게 됩니다. 문의: {email}' },
    ],
  },
  final: { title: '로컬에서 AI를 실행할 준비가 되셨나요?', reqs: 'Apple Silicon 탑재 Mac이라면 모두 지원 · 최소 16GB RAM' },
  footer: {
    tagline: '나만의 로컬 AI 파워하우스 — 온디바이스, MLX 기반, 설계 단계부터 프라이빗.',
    product: '제품', createApp: '앱 만들기', pricing: '가격',
    orgs: "My Org", signIn: 'My Org Admin에 로그인',
    security: "보안", changelog: "변경 내역", docs: "문서", support: "지원",
    company: '회사', privacy: '개인정보 처리방침', terms: '서비스 약관',
    rights: '© 2026 Estha. 모든 권리 보유.',
  },
  proof: { press: "언론 보도", voices: "팀들의 이야기" },
  contact: {
    title: "Estha 팀에 이메일 보내기", copy: "이메일 주소 복사", copied: "복사됨",
    gmail: "Gmail로 작성", mailApp: "메일 앱에서 열기",
    subject: "Estha for Mac 문의",
  },
  share: {
    button: "공유", title: "Estha 공유하기",
    sub: "카드를 골라 올리거나, 링크만 보내 보세요.",
    style: "카드", size: "크기",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "프라이버시" },
    landscape: "가로", portrait: "세로",
    shareImage: "이미지 공유…", download: "이미지 저장", copyImage: "이미지 복사", copied: "복사됨",
    copyLink: "링크 복사", link: "링크", postTo: "공유하기",
    email: "이메일",
    text: "Estha는 오픈소스 AI 모델을 Mac에서 온전히 실행합니다. 프라이빗하고, 오프라인에서도 작동하며, 무료로 다운로드할 수 있습니다.",
    cardCta: "무료 다운로드 · Apple 실리콘 Mac 지원",
    close: "닫기",
  },
  apps: {
    dataAnalyst: { name: 'Data Analyst', description: 'CSV/Excel 파일을 업로드하고 자연어로 질문하세요. 차트, 통계 분석, 데이터 인사이트를 자동으로 생성하며, 모든 처리는 사용자의 Mac에서 로컬로 이루어집니다.', tags: ['CSV / Excel', '자동 차트', '자연어 질의', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: '프레젠테이션 주제를 설명하면 전문적으로 구성된 PowerPoint 덱을 받아보세요. 다단계 AI 파이프라인이 개요, 슬라이드별 내용, 그리고 완성도 높은 .pptx 파일을 생성합니다.', tags: ['.pptx 출력', '자동 레이아웃', '다단계 파이프라인'] },
    pdfReader: { name: 'PDF 리더', description: 'PDF를 열고 바로 질문하세요. 모든 답변은 문서 원문에 근거하며, 클릭 한 번으로 출처 구절로 이동하는 인용이 함께 제공됩니다 — 모두 Mac에서 로컬로 처리됩니다.', tags: ['PDF 질의응답', '검증 가능한 인용', '선택 질문', '100% 로컬'] },
    documentProcessing: { name: 'Document Processing', description: '올인원 문서 전문가입니다. 블로그 글, 소셜 미디어 카피, 법률 조항, 비즈니스 문서를 처음부터 작성합니다. 기존 파일을 편집·최적화하고, 여러 언어로 번역하며, 콘텐츠 품질을 검토합니다. 모든 작업은 사용자의 Mac에서 비공개로 이루어집니다.', tags: ['초안 작성', '편집 및 최적화', '번역', '검토 및 감수'] },
    meetingIntelligence: { name: 'Meeting Intelligence', description: 'AI로 회의를 녹음, 전사, 분석하세요. 회의록, 실행 항목, 주요 결정 사항을 자동으로 생성하며, 오디오가 기기를 벗어나지 않아 완벽한 개인정보 보호가 보장됩니다.', tags: ['전사', '회의록', '실행 항목', '100% 프라이빗'] },
    vibeCoding: { name: 'Vibe Coding: 프로토타입', description: 'AI로 인터랙티브 미리보기를 만드세요. 자연어로 화면을 설명하면 클릭할 수 있는 프로토타입이 생성되고, 그대로 계속 다듬을 수 있습니다. 최종적으로 자체 완결형 .html 파일 하나로 출력됩니다 — 모두 Mac에서 로컬로 생성됩니다.', tags: ['단일 .html 파일', '인터랙티브 미리보기', '클릭하여 편집', '100% 로컬'] },
    translate: { name: "번역", description: "텍스트와 Word·텍스트·Markdown 문서를 번역합니다. 공유 용어집으로 용어를 일관되게 유지하며, 모든 처리는 Mac에서 로컬로 이루어집니다.", tags: ["텍스트 및 문서", ".docx / .txt / .md", "용어집", "100% 로컬"] },
  },
  screens: {
    chat: [
      { label: '스토어 둘러보기', caption: '탐색하고, 설치하고, 고정하세요. 언제나 무료' },
      { label: '설치', caption: '설치하면 지식 베이스가 로컬에 생성됩니다' },
      { label: '질문하기', caption: '플레이북에 근거한 답변' },
    ],
    build: [
      { label: '앱 만들기', caption: 'Quick Bot 또는 고급 — 둘 다 바로 대화 가능' },
      { label: 'Quick Bot', caption: '지식 베이스 업로드. 프롬프트 작성. 게시.' },
      { label: 'Playground', caption: '노드, 분기, 지식을 시각적으로' },
      { label: '게시 완료', caption: '게시 완료, 바로 대화할 수 있습니다' },
    ],
    analyst: [
      { label: '질문하기', caption: '데이터에 자연어로 질문하세요' },
      { label: '분석 중', caption: 'Mac에서 직접 분석' },
      { label: '차트와 인사이트', caption: '답변, 차트, 그리고 분석 과정까지' },
    ],
    ppt: [
      { label: '설정', caption: '주제, 슬라이드 수, 언어, 어조, 테마' },
      { label: '개요 검토', caption: '생성 전에 개요부터 수정하세요' },
      { label: '미리보기', caption: '편집 가능한 완성본 .pptx — Mac에서' },
    ],
    pdf: [
      { label: 'PDF 열기', caption: '논문, 보고서, 매뉴얼, 스캔 문서까지' },
      { label: '읽는 중', caption: '로컬에서 한 페이지씩' },
      { label: '인용된 답변', caption: '모든 답변이 정확한 조항을 가리킵니다' },
    ],
    doc: [
      { label: '구절 선택', caption: '텍스트를 선택하고 원하는 것을 말하세요' },
      { label: '다시 쓰는 중', caption: '문서 안에서 바로 다시 씁니다' },
      { label: '수락 또는 거부', caption: '다시 쓰기, 다듬기, 번역 — 수락하거나 거부하세요' },
    ],
    meeting: [
      { label: '녹음', caption: '이 Mac에서 실시간 전사' },
      { label: '출력 선택', caption: '생성할 항목을 고르세요' },
      { label: '요약', caption: '결정 사항과 실행 항목을 대신 정리합니다' },
      { label: '실행 항목', caption: '담당자와 기한, 근거까지' },
    ],
    vibe: [
      { label: '설명하기', caption: '자연어로 화면을 설명하세요' },
      { label: '생성 중', caption: '전부 이 Mac에서 만들어집니다' },
      { label: '프로토타입', caption: '클릭 가능, 버전 관리, .html 파일 하나' },
      { label: '클릭하여 편집', caption: '아무 부분이나 선택하고 바꿀 내용을 말하세요' },
    ],
    translate: [
      { label: "텍스트 번역", caption: "보라색 단어는 용어집에서 가져옵니다" },
      { label: "문서 번역", caption: ".docx, .txt, .md — 원본은 그대로 유지" },
      { label: "용어집", caption: "용어집으로 모든 용어를 일관되게" },
    ],
    private: [
      { label: '이 Mac에서', caption: '완전히 오프라인. 데이터가 이 기기를 벗어나지 않습니다.' },
      { label: 'Mac Studio Cluster', caption: '더 큰 모델을 온프레미스에서' },
    ],
    org: [
      { label: '조직 앱 공간', caption: '브랜드 공간, 팀을 위해 만든 앱' },
      { label: '엔터프라이즈 플랜', caption: '구성원은 허용된 앱만 열 수 있습니다' },
    ],
  },
};

export default ko;
